/**
 * Join a section's paragraphs into one markdown string for a single
 * <ReactMarkdown> pass.
 *
 * The pages used to render one <ReactMarkdown> per paragraph, which meant a run
 * of bullet lines came out as a stack of separate one-item lists rather than
 * one list. Consecutive bullets are joined with a single newline here so they
 * stay tight; everything else is separated by a blank line as its own
 * paragraph.
 *
 * `•` is rewritten to `-` because the source copy uses the literal character,
 * which markdown treats as ordinary text.
 */
export const toMarkdown = (lines) =>
  lines
    .map((line) => line.trim().replace(/^•\s*/, "- "))
    .reduce((acc, line) => {
      const prev = acc[acc.length - 1];
      if (prev?.startsWith("- ") && line.startsWith("- ")) {
        acc[acc.length - 1] = `${prev}\n${line}`;
        return acc;
      }
      acc.push(line);
      return acc;
    }, [])
    .join("\n\n");
